/** Configuration du client, lue au build (variables VITE_*). */

const mapboxToken = (import.meta.env.VITE_MAPBOX_TOKEN as string | undefined)?.trim() || "";

export const config = {
  /** Moteur de carte : Mapbox GL JS (décision du 27/09/2026, comme Prevail) si un jeton est fourni,
   *  sinon MapLibre GL JS (même famille de rendu) pour pouvoir travailler sans jeton. */
  mapEngine: (mapboxToken ? "mapbox" : "maplibre") as "mapbox" | "maplibre",
  mapboxToken,
  // Style de l'iPad (MapBoxMapView : `.outdoors`) : couleurs, relief, forêts et eau.
  mapboxStyle: (import.meta.env.VITE_MAPBOX_STYLE as string | undefined) || "mapbox://styles/mapbox/outdoors-v12",
  /** Fonds IGN (Géoplateforme, sans clé). En production, ils seront servis par le serveur Generex. */
  ignPlanUrl:
    "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/png",
  ignOrthoUrl:
    "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&STYLE=normal&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/jpeg",
  /** Polices des étiquettes pour le moteur MapLibre (développement). */
  maplibreGlyphs: "https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf",
};
